import { ca } from '@cian/analytics';

export const trackShowCheckbox = (isNewOffer) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Show',
    label: 'Checkbox',
    banner_location: isNewOffer ? 'New_ad' : 'Edit_ad',
  });
};
